import { Component, OnInit } from '@angular/core';
import {PurchaseService} from '../../../services/purchase.service';
import {Trip} from '../../../models/trip.model';
import {Router} from '@angular/router';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-times',
  templateUrl: './times.component.html',
  styleUrls: ['./times.component.scss']
})
export class TimesComponent implements OnInit {

  faCheck = faCheck;

  trips: Trip[];

  groups: {
    dateKey: string,
    date: Date,
    trips: Trip[],
    selected: Trip,
  }[];

  constructor(private purchaseService: PurchaseService,
              private router: Router) { }

ngOnInit(): void {

  this.purchaseService.checkStepAndNavigateIfInvalid('dates');

  this.trips = this.purchaseService.get('dates').trips;

  const selectedTimes: Trip[] =
    this.purchaseService.get('times') || [];

  this.groups = [];

  this.trips.forEach((trip) => {

    const dateKey = trip.date.split('T')[0];

    let existingGroup =
      this.groups.find(group => group.dateKey === dateKey);

    if (!existingGroup) {

      existingGroup = {
        dateKey,
        date: new Date(trip.date),
        trips: [],
        selected: null
      };

      this.groups.push(existingGroup);
    }

    existingGroup.trips.push(trip);

    const previouslySelected = selectedTimes.find(
      selected => selected.id === trip.id
    );

    if (previouslySelected) {
      existingGroup.selected = trip;
    }

    if (!existingGroup.selected) {
      existingGroup.selected = existingGroup.trips[0];
    }

  });

}
  ok(): void {

    this.purchaseService.set('times',
      this.groups
        .map(group => group.selected)
    );

    console.log('trips to buy', this.purchaseService.get('times'));

    this.router.navigate(['steps/checkout']);

  }

}
